import $ from 'jquery';

(() => {

  const contents = '_anchorscroll';

  $(function(){
    $('a[href^="#"]').on('click',function(){
      var minus = 0;
      var speed = 500;
      var href= $(this).attr("href");
      var target = $(href == "#" || href == "" ? 'html' : href);
      console.log(href);
      // console.log(musiclist);
      var windowWidth = window.innerWidth;
      // if (windowWidth > 751) {
      //   // PCの処理
      //   minus = href == '#musiclist' ? -150 : 0;
      // }
      // else if (windowWidth > 768) {
      //   // TABの処理
      // } else {
      //   // S
      // }
      // if(target.length){
        // var position = target.offset().top - $('header').height() - 150 + minus;
        var position = target.offset().top;
        $("html, body").animate({scrollTop:position}, speed, "swing");
      // }
      return false;
    });
  });

})();
